<template>
    <div class="shop-content">
        <ph-header>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <div class="codeContainer">
          <div class="codeImage">
            <img src="https://res.ponhu.cn/new/logo200_200.jpg" alt="">
            <div id="qrcode"><!-- <img src="https://m.ponhu.cn/Public/wap/bing/images/youfei.png" alt="" srcset=""> --></div>
          </div>
          <p>扫描二维码,查看商品详情</p>
        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import QRCode from 'qrcodejs2'
export default {
  name: 'shopGoodQrcode',
  components: {
    PhHeader
  },
  computed: {
    link () {
      return process.env.VUE_APP_ROOT_URL+ 'index.html#/goods/' + this.$route.params.gid
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.qrcode()
    })
  },

  methods: {
    qrcode () {
      let qrcode = new QRCode('qrcode', {
        width: 320,
        height: 320, // 高度
        text: this.link, // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .codeContainer{
    width: 615px;
    padding: 22px;
    margin: 30% auto 0;
    background: #d3b570;
    box-sizing: border-box;

    .codeImage {
      width: 100%;
      padding: 60px;
      background: #FFF;
      box-sizing: border-box;
      position: relative;

      >img {
        position: absolute;
        top: calc(50% - 40px);
        left: calc(50% - 40px);
        width: 80px;
        height: 80px;
        border-radius: 14px;
        pointer-events: none;
      }
    }

    p {
      font-size: 28px;
      margin: 22px 0 0;
      color: #311d05;
      text-align: center;
    }
  }
</style>
